import {
    getDeploymentAccountGroup,
    listDeploymentAccountGroups
} from './queries';

import {GraphQLQuery,} from '@aws-amplify/api';

import {
    GetDeploymentAccountGroup,
    ListDeploymentAccountGroups,
} from "../types";
import {pipelinesClient} from "../../pipelines-api-integration/client";


const client = pipelinesClient;

export const fetchRecords = async () => {
    const response = await client.graphql<GraphQLQuery<ListDeploymentAccountGroups>>({
                                                                                         query: listDeploymentAccountGroups,
                                                                                     });
    return response.data?.listDeploymentAccountGroups.items;
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetDeploymentAccountGroup>>({
                                                                                       query: getDeploymentAccountGroup,
                                                                                       variables: {id: id},
                                                                                   });
    return response.data?.getDeploymentAccountGroup;
};
